import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Button, ButtonGroup, Checkbox, FormControlLabel } from '@mui/material'
import objectStore from '../../stores/objectStore'
import filterStore from '../../stores/filterStore'

import requestStore from '../../stores/requestStore'
import logger from '../../utils/logger'


const CategorySelectorRequest = observer(({ onSelectionChange }) => {
	const [activeCategoryId, setActiveCategoryId] = useState(null) // ID активной категории

	const handleCategoryClick = categoryId => {
		logger.log('🎈 Category Clicked:', categoryId)
		requestStore.setActiveCategoryId(categoryId)
		logger.log('Active Category ID:', activeCategoryId)
		
		// Сбрасываем extraFilter при изменении категории
		requestStore.clearRequestStoreFilter()
	}
	// requestStore.filterForRequest
	const handleSubcategoryChange = subcategory => {
		
		
		// Сначала удаляем все текущие подкатегории
		const selectedSubcategories = [
			...requestStore.filterForRequest.selectedSubcategories,
		]
		for (const sub of selectedSubcategories) {
			requestStore.toggleSubcategory(sub)
		}

		// Затем добавляем выбранную подкатегорию
		requestStore.toggleSubcategory(subcategory)
		
		// Сбрасываем extraFilter при изменении подкатегории
		requestStore.clearRequestStoreFilter()
	}

	return (
		<div>
			{import.meta.env.VITE_SHOW_COMPONENT_NAME === 'true' && <div onClick={() => logger.log('CategorySelectorRequest Render')}>% CategorySelectorRequest %</div>}
			<ButtonGroup variant='contained'   className='mb-4'>
				{objectStore.categories.map(category => (
					<Button
						key={category.id}
						color={
							Number(requestStore.filterForRequest.activeCategoryId) ===
							Number(category.id)
								? 'primary'
								: 'default'
						}
						onClick={() => handleCategoryClick(category.id)}
						size='small'
						sx={{ textTransform: 'none' }}
					>
						{category.name}
					</Button>
				))}
			</ButtonGroup>

			{/* Рендеринг подкатегорий */}
			{requestStore.filterForRequest.activeCategoryId && (
				<div>
					{objectStore.categories
						.find(
							cat =>
								Number(cat.id) ===
								Number(requestStore.filterForRequest.activeCategoryId)
						)
						?.subcategories.map(subcategory => (
							<FormControlLabel
								key={subcategory.id}
								control={
									<Checkbox
										checked={requestStore.filterForRequest.selectedSubcategories.some(
											sub => sub.id === subcategory.id
										)}
										onChange={() => handleSubcategoryChange(subcategory)}
									/>
								}
								label={subcategory.name}
							/>
						))}
				</div>
			)}
		</div>
	)
})

export default CategorySelectorRequest